<div class="container">
  <h1>Paramétrage de l’application</h1>

  <div class="section-header">
    <div class="information-container">
      <app-report-message
        [backgroundColor]="Color.white"
        [message]="'Les paramètres seront appliqués à l’ensemble des utilisateurs une fois enregistrés.'"
      ></app-report-message>
    </div>

    <div class="section-header-button">
      <app-button data-testid="save-settings" (onclick)="save()" [isLoading]="isLoading" [isDisabled]="!hasChanges">
        <app-icon [phosphorClass]="'ph-floppy-disk'"></app-icon>
      </app-button>
    </div>
  </div>

  <div class="configuration-container">
    <div class="setting-container all-line-container">
      <h4 class="subtitle-setting">Gestion des factures</h4>
      <div class="setting">
        <label>
          <b>Quota de factures à valider avant envoi (%)</b>
        </label>
        <app-input-number
          id="quota"
          placeholder="Entrer un pourcentage"
          [min]="0"
          [max]="100"
          [maxLength]="3"
          [specialCase]="true"
          [value]="quota"
          (valueChange)="quotaChange($event)"
          data-testid="quota-setting"
        ></app-input-number>
      </div>

      <div class="setting">
        <label>
          <b>Seuil minimum accepté pour envoi de factures (€)</b>
        </label>
        <app-input-number
          id="treshold"
          placeholder="Entrer montant HT en €"
          [value]="threshold"
          (valueChange)="tresholdStateChange($event)"
          data-testid="threshold-setting"
        ></app-input-number>
      </div>
    </div>
  </div>
</div>
